import axios, { AxiosPromise } from "axios";
import {AppResourceApi, SsoMember, InitDto, LoginDto, LoginResponse} from "../generated/dashboard-client";
import { env } from "../env/env";
import { dashboardApiConfig, ops } from "./config";

const api = new AppResourceApi(dashboardApiConfig);

const AppApi = {
  init(loginToken: string = ""): AxiosPromise<InitDto> {
    return api.init(ops(loginToken));
  },

  getGoogleMember(token: string): AxiosPromise<SsoMember> {
    return api.googleLogin(token);
  },

  getMicrosoftMember(token: string): AxiosPromise<SsoMember & { exists?: boolean }> {
    return api.microsoftLogin(token);
  },

  checkEmail(email: string): AxiosPromise<boolean> {
    return api.checkEmail(email, ops());
  },

  login(dto: LoginDto): AxiosPromise<LoginResponse> {
    return api.login(dto);
  },

  loginHandoff(code: string): AxiosPromise<LoginResponse> {
    return axios.post(`${env.apiPath}/public/login/handoff`, { code });
  }
};

export default AppApi;
